var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M9.5,19.25c0,.69-.56,1.25-1.25,1.25h-2.5c-2.07,0-3.75-1.68-3.75-3.75h0V6.75c0-2.07,1.68-3.75,3.75-3.75h2.5c.69,0,1.25,.56,1.25,1.25s-.56,1.25-1.25,1.25h-2.5c-.69,0-1.25,.56-1.25,1.25h0v10c0,.69,.56,1.25,1.25,1.25h2.5c.69,0,1.25,.56,1.25,1.25h0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M21.63,12.63l-5,5c-.49,.49-1.28,.49-1.77,0-.49-.49-.49-1.28,0-1.77l2.87-2.87H9.5c-.69,0-1.25-.56-1.25-1.25,0-.69,.56-1.25,1.25-1.25h8.23l-2.87-2.87c-.47-.51-.43-1.3,.07-1.77,.48-.44,1.22-.44,1.69,0l5,5c.49,.49,.49,1.28,0,1.76",
    fill: "#f90014"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ade6229686fbb0da089be0da4f0af525.svg";
export { ForwardRef as ReactComponent };